import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import Const from '@/helper/const'
import {
  FileDownloadButton
} from '@/components'

export default {
  components: {
    FileDownloadButton
  },
  data () {
    return {
      rules: {
        email: () => (!this.email || this.validateEmail) || 'E-mail precisa ser válido',
        datadc: (value) => this.validateDate(value) || 'Insira um valor válido e tente novamente'
      },
      startDate: moment().format('DD/MM/YYYY'),
      startDateFormated: moment().format('DD/MM/YYYY'),
      endDate: moment().format('DD/MM/YYYY'),
      endDateFormated: moment().format('DD/MM/YYYY'),
      menuEndDate: false,
      menuStartDate: false,
      isLoading: false,
      email: null,
      orderNumber: null,
      selectedTransactionStatus: null,
      listTransactionStatus: [
        { name: 'Aprovado', value: 'approved' },
        { name: 'Rejeitado', value: 'rejected' },
        { name: 'Cancelado', value: 'cancelled' },
        { name: 'Charged Back', value: 'charged_back' },
        { name: 'Pendente', value: 'pending' },
        { name: 'Devolvido', value: 'refunded' },
        { name: 'Processando', value: 'in_process' }
      ],
      selectedPaymentType: null,
      listPaymentType: [
        { name: 'Cartão', value: 'credit_card' },
        { name: 'Boleto', value: 'ticket' }
      ],
      purposeOfPayment: null,
      listPurposeOfPayment: [
        { name: 'Dossiê', value: 'generate_dossier' },
        { name: 'Adição de Crédito', value: 'add_credit' }
      ],
      pagination: {},
      selected: [],
      headers: [
        { text: 'Ações', value: 'actions', align: 'center' },
        { text: 'E-mail', value: 'email', align: 'left' },
        { text: 'Nome', value: 'name', align: 'left' },
        { text: 'Tipo da Compra', value: 'purpose_of_payment', align: 'left' },
        { text: 'Tipo de Pagamento', value: 'payment_type_id', align: 'left' },
        { text: 'Status do Pagamento', value: 'transaction_status', align: 'left' },
        { text: 'Detalhe do Pagamento', value: 'transaction_status_detail', align: 'left' },
        { text: 'Ordem de Compra', value: 'order_number', align: 'left' },
        { text: 'Data da Compra', value: 'datetime_created', align: 'left' },
        { text: 'Última Atualização', value: 'datetime_updated', align: 'left' },
        { text: 'Valor', value: 'unit_price', align: 'right' },
        { text: 'Data da Adição de Crédito', value: 'datetime_credit_added', align: 'left' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getterAllReportsMercadoPago'
    ]),
    validateEmail () {
      const regex = /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/

      return regex.test(this.email)
    },
    isDisabled () {
      return (!this.startDate || !this.endDate) || (this.email && !this.validateEmail)
    },
    reportsMercadoPago () {
      return this.getterAllReportsMercadoPago && this.getterAllReportsMercadoPago.results ? this.getterAllReportsMercadoPago.results : []
    },
    options () {
      return {
        loading: this.isLoading
      }
    }
  },
  watch: {
    pagination: {
      handler () {
        if (this.reportsMercadoPago && this.reportsMercadoPago.length > 0) {
          this.getAllReportsMercadoPago()
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions([
      'actionGetAllReportsMercadoPago'
    ]),
    redirectToStackTrace (item) {
      if (item.callmanager && item.callmanager.length === 1 && Object.prototype.hasOwnProperty.call(item.callmanager[0], 'id_callmanager')) {
        this.$router.push({ name: 'StackTrace', query: { idCallManager: item.callmanager[0].id_callmanager } })
      } else {
        this.sendToast({
          text: 'O item que você clicou não contém as informações necessárias para ser visualizado!',
          type: 'warning'
        })
      }
    },
    linkToDownload (item) {
      let result = ''

      if (item.callmanager && item.callmanager.length === 1 && (Object.prototype.hasOwnProperty.call(item.callmanager[0], 'id_callmanager') && Object.prototype.hasOwnProperty.call(item.callmanager[0], 'id_provider_flow'))) {
        result = `${Const.SERVICE_DOSSIE}/${item.callmanager[0].id_provider_flow}/${item.callmanager[0].id_callmanager}`
      }

      return result
    },
    linkToDownloadAllReports () {
      return `${Const.SERVICE_DOWNLOAD_SPREADSHEET_ALL}/mercado-pago-report?start_date=${`${moment(this.startDate, 'DD/MM/YYYY').format('YYYY-MM-DD')}T00:00:00`}&end_date=${`${moment(this.endDate, 'DD/MM/YYYY').format('YYYY-MM-DD')}T23:59:59`}&size=${this.getterAllReportsMercadoPago.totalResults}`
    },
    checkHasFiltersToFill () {
      const { query } = this.$route

      if (Object.keys(query).length > 0) {
        if (query.email) {
          this.email = query.email
        }

        if (query.order_number) {
          this.orderNumber = query.order_number
        }

        if (query.payment_type_id) {
          this.selectedPaymentType = query.payment_type_id
        }

        if (query.purpose_of_payment) {
          this.purposeOfPayment = query.purpose_of_payment
        }

        if (query.transaction_status) {
          this.selectedTransactionStatus = query.transaction_status
        }

        if (query.start_date && query.end_date) {
          this.startDateFormated = moment(query.start_date, 'DD/MM/YYYY').format('DD/MM/YYYY')
          this.endDateFormated = moment(query.end_date, 'DD/MM/YYYY').format('DD/MM/YYYY')
          this.startDate = moment(query.start_date, 'DD/MM/YYYY').format('YYYY-MM-DD')
          this.endDate = moment(query.end_date, 'DD/MM/YYYY').format('YYYY-MM-DD')
        }
      }
    },
    capitalize (val) {
      return val[0].toUpperCase() + val.slice(1)
    },
    validateDate (date) {
      if (!date) {
        return true
      }
      const isDateValid = moment(date, 'DD/MM/YYYY').format('DD/MM/YYYY')
      if (isDateValid !== 'Invalid date') {
        return true
      }
      return false
    },
    formatDate (date) {
      return moment(date).format('DD/MM/YYYY [às] HH:mm:ss')
    },
    treatmentMessageTransactionStatus (value) {
      return ({
        approved: 'Aprovado',
        rejected: 'Rejeitado',
        cancelled: 'Cancelado',
        charged_back: 'Charged Back',
        pending: 'Pendente',
        refunded: 'Devolvido',
        in_process: 'Processando'
      }[value] || 'Desconhecido')
    },
    treatmentMessagePaymentType (value) {
      return ({
        credit_card: 'Cartão',
        ticket: 'Boleto'
      }[value] || 'Desconhecido')
    },
    treatmentMessagePurposeOfPayment (value) {
      return ({
        generate_dossier: 'Dossiê',
        add_credit: 'Adição de Crédito'
      }[value] || 'Desconhecido')
    },
    treatmentMessageTransactionStatusDetail (value) {
      return ({
        accredited: 'Creditado',
        cc_rejected_high_risk: 'Rejeitado Alto Risco',
        cc_rejected_call_for_authorize: 'Pedido de Autorização Rejeitado',
        expired: 'Expirado',
        cc_rejected_other_reason: 'Rejeitou Outro Motivo',
        cc_rejected_bad_filled_card_number: 'Rejeitado Número de Cartão com Preenchimento Incorreto',
        cc_rejected_bad_filled_other: 'Rejeitado Ruim Preenchido Outro',
        cc_rejected_insufficient_amount: 'Quantidade Insuficiente Rejeitada',
        cc_rejected_bad_filled_date: 'Data de Preenchimento Incorreta Rejeitada',
        cc_rejected_bad_filled_security_code: 'Código de Segurança Preenchido Incorreto Rejeitado',
        cc_rejected_max_attempts: 'Tentativas Máximas Rejeitadas',
        cc_rejected_blacklist: 'Lista Restritiva Rejeitada',
        cc_rejected_card_disabled: 'Cartão Rejeitado Desativado',
        rejected_by_bank: 'Rejeitado pelo Banco',
        by_payer: 'Pelo Pagador',
        reimbursed: 'Reembolsado',
        pending_waiting_payment: 'Pagamento em Espera Pendente',
        refunded: 'Devolvido'
      }[value] || 'Desconhecido')
    },
    getAllReportsMercadoPago () {
      if (!this.isDisabled) {
        const { query } = this.$route

        const {
          sortBy, descending, page, rowsPerPage
        } = this.pagination

        let params = {
          sortBy: this.capitalize(sortBy),
          descending,
          page,
          size: rowsPerPage,
          purpose_of_payment: this.purposeOfPayment || null,
          payment_type_id: this.selectedPaymentType || null,
          transaction_status: this.selectedTransactionStatus || null,
          order_number: this.orderNumber || null,
          email: this.email || null,
          start_date: `${moment(this.startDate, 'DD/MM/YYYY').format('YYYY-MM-DD')}T00:00:00` || '',
          end_date: `${moment(this.endDate, 'DD/MM/YYYY').format('YYYY-MM-DD')}T23:59:59` || ''
        }

        if (Object.keys(query).length > 0) {
          params = {
            ...params,
            ...query
          }
        }

        this.isLoading = true

        this.actionGetAllReportsMercadoPago(params)
          .then(() => {
            this.isLoading = false
          })
          .catch(() => {
            this.isLoading = false

            this.sendToast({
              text: 'Ocorreu um erro ao buscar os relatórios, tente novamente mais tarde.',
              type: 'danger'
            })
          })
      } else {
        this.sendToast({
          text: 'Não foi possível gerar o relatório, confira se os campos estão preenchidos corretamente!',
          type: 'warning'
        })
      }
    },
    clearFields () {
      this.purposeOfPayment = this.selectedPaymentType = this.selectedTransactionStatus = this.orderNumber = this.email = null
      this.startDate = moment(new Date().toJSON().slice(0, 10).replace(/-/g, '-')).toISOString()
      this.endDate = moment(new Date().toJSON().slice(0, 10).replace(/-/g, '-')).toISOString()
      this.startDateFormated = this.endDateFormated = moment().format('DD/MM/YYYY')
      this.getAllReportsMercadoPago()
    }
  }
}
